import * as React from 'react'

import { Container, Box, Title } from './switch.style'

interface SwitchProps {
  count: number
  firstBtn: string
  secondBtn: string
  thirdBtn?: string
  showFirst: boolean
  showFirstFn: any
  showSecond: boolean
  showSecondFn: any
  showThird?: boolean
  showThirdFn?: any
  secondLazyLoad?: () => void
}

const Switch: React.FC<SwitchProps> = ({
  count,
  firstBtn,
  secondBtn,
  thirdBtn,
  showFirst,
  showFirstFn,
  showSecond,
  showSecondFn,
  showThird,
  showThirdFn,
  secondLazyLoad,
}) => {
  const isThird = bool => typeof showThird === 'boolean' && showThirdFn(bool)

  const handleShowFirst = () => {
    showFirstFn(true)
    showSecondFn(false)
    isThird(false)
  }
  const handleShowSecond = () => {
    showFirstFn(false)
    showSecondFn(true)
    isThird(false)
    secondLazyLoad && secondLazyLoad()
  }
  const handleShowThird = () => {
    showFirstFn(false)
    showSecondFn(false)
    isThird(true)
  }

  const switchView = () => {
    switch (count) {
      case 2:
        return (
          <Container>
            <Box
              className={showFirst ? 'primary switch__left' : 'secondary switch__left'}
              onClick={handleShowFirst}
            >
              <Title>{firstBtn}</Title>
            </Box>
            <Box
              className={showSecond ? 'primary switch__right' : 'secondary switch__right'}
              onClick={handleShowSecond}
            >
              <Title>{secondBtn}</Title>
            </Box>
          </Container>
        )

      case 3:
        return (
          <Container>
            <Box
              className={showFirst ? 'primary switch__left' : 'secondary switch__left'}
              onClick={handleShowFirst}
            >
              <Title>{firstBtn}</Title>
            </Box>
            <Box className={showSecond ? 'primary' : 'secondary'} onClick={handleShowSecond}>
              <Title>{secondBtn}</Title>
            </Box>
            <Box
              className={showThird ? 'primary switch__right' : 'secondary switch__right'}
              onClick={handleShowThird}
            >
              <Title>{thirdBtn}</Title>
            </Box>
          </Container>
        )
    }
    return
  }

  return <>{switchView()}</>
}

export default Switch



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/switch/switch.tsx